module.exports = __webpack_public_path__ + "img/BasketballBG.aa4051e8.jpg";